module.exports = __webpack_public_path__ + "img/WY.8d93eb76.png";